import { render, staticRenderFns } from "./TextUserInput.vue?vue&type=template&id=6b9897d5&"
import script from "./TextUserInput.vue?vue&type=script&lang=js&"
export * from "./TextUserInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports